export default "__VITE_ASSET__DJ_EV9RY__"